import './ModalControlledView.scss'
import React from "react";
import {Modal, Header, Button, Icon} from 'semantic-ui-react'

import {getLanguageScope} from "../../../../helpers";

const _i18n = getLanguageScope('modal');

class ModalControlled extends React.Component {

  constructor(props) {
    super(props);
  }

  render(){
    const {onNext, onClose, showModal, headerText, bodyText, noText, yesText, icon, centered} = this.props;

    let bodyTextView = null;

    if(bodyText) {
      bodyTextView = (
        <Modal.Content>
          <p>
            {bodyText}
          </p>
        </Modal.Content>
      )
    }

    return (
      <Modal style={{height: 'auto'}} closeOnDimmerClick={true} open={showModal} onClose={() => onClose} size='small' centered={centered}>
        <Header icon={icon ? icon : 'question circle'} content={headerText ? headerText : _i18n('header')} />
        {bodyTextView}
        <Modal.Actions>
          <Button onClick={() => onClose()} color='red' inverted>
            <Icon name='remove' /> {noText ? noText :_i18n('no')}
          </Button>
          <Button onClick={() => onNext()} color='green' inverted>
            <Icon name='checkmark' /> {yesText ? yesText :_i18n('yes')}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default ModalControlled


// WEBPACK FOOTER //
// ./src/components/shared/ModalControlled/components/ModalControlledView.js